// extracted by mini-css-extract-plugin
export default {"emailColumns":"EmailInputSection_emailColumns__9OnAJ","emailLabel":"EmailInputSection_emailLabel__Rrhng"};